interface Month {
  label: string;
  value: string;
}
interface AppConfig {
  currency: string;
  otpExpiresIn: number;
  uploadSize: number;
  galleryImageSize: number;
  rialExchangeRate: number;
  noAuthentication: string[];
  acceptImageTypes: string[];
  siteUrl: string;
  witroAppUrl: string;
  persianMonth: Month[];
  supportPhoneNumber: string;
  supportIranianPhoneNumber: string;
  supportPhoneNumber2: string;
  supportIranianPhoneNumber2: string;
  witroMagUrl: string;
}

export const appConfigs: AppConfig = {
  currency: 'تومان',
  uploadSize: 5120,
  galleryImageSize: 2048,
  otpExpiresIn: 180000,
  rialExchangeRate: 10,
  supportPhoneNumber: '+982191031801',
  supportIranianPhoneNumber: '021-91031801',
  supportPhoneNumber2: '+982192003494',
  supportIranianPhoneNumber2: '021-92003494',
  noAuthentication: ['/otp/', '/register/'],
  acceptImageTypes: ['image/jpeg', 'image/png'],
  siteUrl: 'https://goldenvitrin.ir/',
  witroAppUrl:
    process.env.NEXT_PUBLIC_APP_URL_VENDOR || 'https://app.witro.shop',
  witroMagUrl: 'https://witro.shop/mag/',
  persianMonth: [
    { label: 'فروردین', value: '1' },
    { label: 'اردیبهشت', value: '2' },
    { label: 'خرداد', value: '3' },
    { label: 'تیر', value: '4' },
    { label: 'مرداد', value: '5' },
    { label: 'شهریور', value: '6' },
    { label: 'مهر', value: '7' },
    { label: 'آبان', value: '8' },
    { label: 'آذر', value: '9' },
    { label: 'دی', value: '10' },
    { label: 'بهمن', value: '11' },
    { label: 'اسفند', value: '12' },
  ],
};
